export default __webpack_public_path__ + "static/media/Isometric_Square_pink.1b2d4e40.svg";